import type { PlaceTranslation } from '../../types/place';

interface Widget {
    to: string;
    text: Record<string, string>;
    attribute: string;
    active: number;
    action?: string;
}

 const widgets: Widget[] = [
    {
        to: 'video',
        text: {
            heIL: 'סרטון התחנה',
            enUS: 'Station Video'
        },
        attribute: 'video',
        active: 0
    },    
    {
        to: 'audio',
        text: {
            heIL: 'אודיו התחנה',
            enUS: 'Station Audio'
        },
        attribute: 'audio',
        active: 0
    },    
    {
        to: 'text',
        text: {
            heIL: 'טקסט התחנה',
            enUS: 'Station Text'
        },
        attribute: 'information_description',
        active: 0
    },    
    {
        to: 'accessible-video',
        text: {
            heIL: 'סרטון \n לכבדי שמיעה',
            enUS: 'Hearing accessibility video'
        },
        attribute: 'accessibility_hearing_video_sign_language',
        active: 0,
        action: 'ACCESSIBILITY_MODAL'
    },    
    {
        to: 'audio-description',
        text: {
            heIL: "תיאור המייצג לכבדי ראיה",
            enUS: 'Station Audio description'
        },
        attribute: 'accessibility_vision_audio_description',
        active: 0
    },    {
        to: 'chat',
        text: {
            heIL: "מדריך וירטואלי",
            enUS: 'Virtual guide'
        },
        attribute: 'agent',
        active: 1
    },
]


//i use widget.active++, so that if there are > 1 relevant widgets, a type modal will be appeared
export const configureWidgets = (stationWidgets: PlaceTranslation): Widget[] => {

    const res = widgets.map(widget => {
        switch (widget.to) {
            case 'audio':
                if (stationWidgets.audio !== null) 
                    return { ...widget, active: widget.active + 1}
                return widget
            case 'video':
                if (stationWidgets.video !== null)
                    return {...widget, active: widget.active + 1}
                return widget
            case 'text':
                if (stationWidgets.information_description !== null)
                    return {...widget, active: widget.active + 1}
                return widget;
            case 'accessible-video':
                if (stationWidgets.accessibility_hearing_video_sign_language !== null || stationWidgets.accessibility_hearing_video_subtitles !== null) 
                    return {...widget, active: widget.active + 1}
                return widget
            case 'audio-description':
                if (stationWidgets.accessibility_vision_audio_description !== null) 
                    return {...widget, active: widget.active + 1}
                return widget
            default:
                return widget
        }
    })

    return res;
}
